import request from "@/utils/request";
import { formateObjToParamStr } from "@/utils";
// import { encryptByDES } from '@/utils/crypto'
import qs from "qs";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;
const REAL_BASE_API =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_REAL_BASE_API
    : process.env.VUE_APP_BASE_API;
// 统计
export function getDefaultDate(param) {
  return request({
    url: `${BASE_API}/api/latesttime`,
    method: "get",
    params: param,
  });
}

// 统计
export function getStatisticsData(param) {
  return request({
    url: `${BASE_API}/api/summary`,
    method: "get",
    params: param,
  });
}
//饼图
export function getPieChartData(param) {
  return request({
    url: `${BASE_API}/api/summary`,
    method: "get",
    params: param,
  });
}
export function getPieChartDatapost(data) {
  return request({
    url: `${BASE_API}/api/summary`,
    method: "post",
    data: data,
  });
}
//获取饼图下载地址
export function getPieChartDataUrl(param) {
  return `${REAL_BASE_API}/api/summary?` + formateObjToParamStr(param);
}
//声量图
export function getVolumeTable(param) {
  return request({
    url: `${BASE_API}/api/posts_analyse`,
    method: "get",
    params: param,
  });
}
export function getVolumeTablepost(data) {
  return request({
    url: `${BASE_API}/api/posts_analyse`,
    method: "post",
    data: data,
  });
}
//趋势图
export function getMixChartData(param) {
  return request({
    url: `${BASE_API}/api/trend`,
    method: "get",
    params: param,
  });
}
export function getMixChartDatapost(data) {
  return request({
    url: `${BASE_API}/api/trend`,
    method: "post",
    data: data,
  });
}
//词云图
export function getWords(param) {
  return request({
    url: `${BASE_API}/api/cloud`,
    method: "get",
    params: param,
  });
}
export function getWordspost(data) {
  return request({
    url: `${BASE_API}/api/cloud`,
    method: "post",
    data: data,
  });
}
//获取词云图下载地址
export function getWordCloudDataUrl(param) {
  return `${REAL_BASE_API}/api/cloud?` + formateObjToParamStr(param);
}
// 帖子列表
export function getpostsList(param) {
  return request({
    url: `${BASE_API}/api/posts/list`,
    method: "get",
    params: param,
  });
}
export function getpostsListpost(data) {
  return request({
    url: `${BASE_API}/api/posts/list`,
    method: "post",
    data: data,
  });
}
//获取帖子列表的下载地址
export function getpostsListDataUrl(param) {
  return `${REAL_BASE_API}/api/posts/list?` + formateObjToParamStr(param);
}
//获取录音原文的下载地址
export function getRecordingDataUrl(param) {
    return `${BASE_API}/api/download?` + formateObjToParamStr(param);
}
//达人榜
export function getTalentData(param) {
  return request({
    url: `${BASE_API}/api/kols/list`,
    method: "get",
    params: param,
  });
}
export function getTalentDatapost(data) {
  return request({
    url: `${BASE_API}/api/kols/list`,
    method: "post",
    data: data,
  });
}
//品牌排行榜
export function getBrandData(param) {
  return request({
    url: `${BASE_API}/api/brands/list`,
    method: "get",
    params: param,
  });
}
export function getBrandDatapost(data) {
  return request({
    url: `${BASE_API}/api/brands/list`,
    method: "post",
    data: data,
  });
}
//保存方案
export function saveProj(param) {
  return request({
    url: `${BASE_API}/api/plan`,
    method: "get",
    params: param,
  });
}

//根据id查询名称
export function getNameById(param) {
  return request({
    url: `${BASE_API}/api/idname`,
    method: "get",
    params: param,
  });
}
